export default __webpack_public_path__ + "static/media/screenshot3.cab2bd2c.png";